import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.symbol.js';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es6.object.get-own-property-descriptor.js';
import 'core-js/modules/es7.object.get-own-property-descriptors.js';
import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { Toaster, Position } from '@blueprintjs/core';
import React__default, { useState, useMemo } from 'react';
import { Icon } from '../icon/icon.js';
import { CheckmarkFilled32, WarningFilled32, WarningAltFilled32, InformationFilled32 } from '@carbon/icons-react';
import { identity } from 'ramda';

var _excluded = ["children", "transform"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var defaultToaster = typeof document !== "undefined" ? Toaster.create({
  position: "top-right"
}) : {
  dismiss: function dismiss() {},
  clear: function clear() {},
  getToasts: function getToasts() {
    return [];
  },
  show: function show() {
    return '';
  }
};
var ToasterContext = /*#__PURE__*/React__default.createContext(defaultToaster);
var ToastProvider = function ToastProvider(_ref) {
  var children = _ref.children,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? identity : _ref$transform,
      toasterProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(defaultToaster),
      _useState2 = _slicedToArray(_useState, 2),
      toaster = _useState2[0],
      setToaster = _useState2[1];

  var extendedToaster = useMemo(function () {
    if (!toaster) {
      return toaster;
    }

    var newToaster = {
      dismiss: function dismiss(key) {
        return toaster.dismiss(key);
      },
      clear: function clear() {
        return toaster.clear();
      },
      getToasts: function getToasts() {
        return toaster.getToasts();
      },
      show: function show(props, key) {
        var finalProps = props;

        if (props.icon === undefined) {
          // This could be its own transform, but these are the default icons as defined by
          finalProps = _objectSpread(_objectSpread({}, props), {}, {
            icon: /*#__PURE__*/React__default.createElement(Icon, null, props.intent === "success" ? /*#__PURE__*/React__default.createElement(CheckmarkFilled32, null) : props.intent === "danger" ? /*#__PURE__*/React__default.createElement(WarningFilled32, null) : props.intent === "warning" ? /*#__PURE__*/React__default.createElement(WarningAltFilled32, null) : props.intent === "primary" ? /*#__PURE__*/React__default.createElement(InformationFilled32, null) : /*#__PURE__*/React__default.createElement(InformationFilled32, null))
          });
        }

        return toaster.show(transform(finalProps), key);
      }
    };
    return newToaster;
  }, [toaster]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Toaster, _extends({
    position: Position.TOP_RIGHT,
    ref: function ref(node) {
      if (node) {
        setToaster(node);
      }
    }
  }, toasterProps)), /*#__PURE__*/React__default.createElement(ToasterContext.Provider, {
    value: extendedToaster
  }, children));
};

export { ToastProvider, ToasterContext };
//# sourceMappingURL=toaster-provider.js.map
